export const TooltipFMEConstants = {
    ENTER: "enter",
    LEAVE: "leave",
};
